export default __webpack_public_path__ + "static/media/btn-light-on.2ee48c78.svg";